import { useContext } from "react";
import { FirmaFiltersContext } from "../../../../../context/FiltersContext";
import {
  QueryFilter,
  FirmaFilterKeys,
} from "../../../../../interfaces/filters";
import { AccordionFilterItem } from "../../../../accordion/Accordion";
import FirmaAdvokatkredsFilter from "./FirmaAdvokatkredsFilter";
import FirmaKommuneFilter from "./FirmaKommuneFilter";
import FirmaLandeFilter from "./FirmaLandeFilter";
import FirmaPostnummerFilter from "./FirmaPostnummerFilter";
import FirmaRegionFilter from "./FirmaRegionFilter";
import FirmaRetskredsFilter from "./FirmaRetskredsFilter";
import FirmaVejnavnFilter from "./FirmaVejnavnFilter";

// helper
const filterKeys: Array<QueryFilter<FirmaFilterKeys>["filterKey"]> = [
  "vejnavn",
  "postnummer",
  "kommune",
  "region",
  "country",
  "advokatkreds",
  "retskreds",
];

export default function FirmaGeografiFilter() {
  // query filter context
  const filters = useContext(FirmaFiltersContext);

  // find the filter settings
  const allSettings = filters.flatMap((set) => {
    if (set.filterKey === filterKeys.find((key) => key === set.filterKey)) {
      return set;
    } else {
      return [];
    }
  });

  // check if any settings are active
  const hasAnyActiveSetting = allSettings.some((set) => set.settings);

  return (
    <AccordionFilterItem
      title="Geografi"
      value="geografi"
      isActive={hasAnyActiveSetting}
    >
      <FirmaVejnavnFilter />
      <FirmaPostnummerFilter />
      <FirmaKommuneFilter />
      <FirmaRegionFilter />
      <FirmaLandeFilter />
      <FirmaAdvokatkredsFilter />
      <FirmaRetskredsFilter />
    </AccordionFilterItem>
  );
}
